<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_product_ProductInfo.1')" :paths="paths"></g-page-title>
    </template>
    <g-contents>

      <div class="-container-resizing">
        <div class="-p-5">
          <section class="-wrapper-column -wrapper-tile">
            <div class="-header">
              <p class="-h2">{{$t('pages_product_ProductInfo.2')}}</p>
              <g-button id="product-productinfo-g-button-01" variant="secondary" size="small" @click="onClickProductEdit" v-if="hasAuth">
                <g-icon name="create"></g-icon>
                <span>{{$t('pages_product_ProductEdit.1')}}</span>
              </g-button>
            </div>

            <div class="-width-100 -tile-container -wrapper-half nowrap- white-space-normal">
              <section class="-wrapper-tile">
                <div class="-div-table">
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.1')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1 -font-size-14" id="product-productinfo-span-01">{{selectProductInfo.stratNameLv1}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.2')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1" id="product-productinfo-span-02">{{selectProductInfo.stratNameLv2}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.3')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1" id="product-productinfo-span-03">{{selectProductInfo.category}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.4')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1" id="product-productinfo-span-04">{{selectProductInfo.productName}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.5')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1" id="product-productinfo-span-05" v-html="selectProductInfo.remark"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section class="-wrapper-tile">
                <div class="-div-table">
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.6')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <div class="-height-100 -wrapper-v-center">
                        <g-switch id="product-productinfo-g-switch-01" :checked="selectProductInfo.isNew === 'Y'" disabled/>
                      </div>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.7')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <div class="-height-100 -wrapper-v-center">
                        <g-switch id="product-productinfo-g-switch-02" :checked="selectProductInfo.stat === 'Y'" disabled/>
                      </div>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.8')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span id="product-productinfo-span-06" class="-font-size-14 -mr-2" v-if="selectProductInfo.userName">{{selectProductInfo.userName}}</span>
                        <a id="product-productinfo-a-01" :href="`mailto:${selectProductInfo.userId}`" class="-font-size-12 blue-1">{{selectProductInfo.userId}}</a>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.9')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <div class="-height-100 -wrapper-v-center">
                        <span id="product-productinfo-span-07" class="-font-size-14 -mr-2">{{selectProductInfo.lastUpdateDate}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.10')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <div class="-height-100 -wrapper-column">
                        <div class="-wrapper-v-center">
                          <div class="-wrapper-v-center -button-ui" v-if="selectProductInfo.brochureFileName" @click="onClickDownload(selectProductInfo.brochureFileId)">
                            <g-icon id="product-productinfo-g-icon-01" :name="getFileIcon(selectProductInfo.brochureFileName)" size="large" class="nowrap- -mr-2"/>
                            <span id="product-productinfo-span-08" class="-font-size-14 darkgray-1">{{selectProductInfo.brochureFileName}}</span>
                          </div>
                          <div class="-wrapper-v-center"  v-else>
                            <span class="-paragraph -ml-1 -font-size-14">-</span>
                          </div>
                        </div>
                        <!-- <div class="-wrapper-v-center nowrap-">
                          <span class="ci ci-file-doc large- -mr-2"></span>
                          <span class="-font-size-14 darkgray-1">bespinglobal_20201118.doc</span>
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.11')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <div class="-wrapper-v-center -button-ui" v-if="selectProductInfo.introFileName" @click="onClickDownload(selectProductInfo.introFileId)">
                        <g-icon id="product-productinfo-g-icon-02" :name="getFileIcon(selectProductInfo.introFileName)" size="large" class="nowrap- -mr-2"/>
                        <span id="product-productinfo-span-09" class="-font-size-14 darkgray-1">{{selectProductInfo.introFileName}}</span>
                      </div>
                      <div class="-wrapper-v-center" v-else>
                        <span class="-paragraph -ml-1 -font-size-14">-</span>
                      </div>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_product_ProductInfo.title.12')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <div class="-wrapper-v-center -button-ui" v-if="selectProductInfo.etcFileName" @click="onClickDownload(selectProductInfo.etcFileId)" >
                        <g-icon id="product-productinfo-g-icon-03" :name="getFileIcon(selectProductInfo.etcFileName)" size="large" class="nowrap- -mr-2"/>
                        <span id="product-productinfo-span-10" class="-font-size-14 darkgray-1">{{selectProductInfo.etcFileName}}</span>
                      </div>
                      <div class="-wrapper-v-center" v-else>
                        <span class="-paragraph -ml-1 -font-size-14">-</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </section>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FileService from '@/services/FileServices'
import FileDownloader from '@/library/FileDownloader'
import {AUTH_GROUP} from '@/constants/constants'
import CodeCreate from '@/code/CodeCreate'

export default {
  name: 'product-info',
  componentName: 'ProductInfo',
  data() {
    return {
      paths: [{
        path: '/product/list',
        name: this.$t('pages_product_ProductList.1')
      }, {
        name: this.$t('pages_product_ProductInfo.1')
      }]
    }
  },
  computed: {
    ...mapGetters('product', ['selectProductInfo', 'codeSelectProductInfo']),
    ...mapGetters('user', ['userInfo']),
    hasAuth () {
      return this.userInfo.auth === AUTH_GROUP.BespinAdmin
    }
  },
  methods: {
    ...mapActions('product', ['getSelectProductInfo', 'clearSelectProductInfo']),
    onClickDownload (fileId) {
      FileDownloader.fileDownload(fileId)
    },
    onClickProductEdit () {
      this.$router.push(`/product/edit?stratCode=${this.selectProductInfo.stratCode}`)
    },
    getFileIcon(fileName) {
      return FileDownloader.getFileIcon(fileName)
    }
  },
  watch: {
    codeSelectProductInfo () {
      if (this.codeSelectProductInfo === CodeCreate.EXCEPTION) {
        this.$router.go(-1)
      }
    }
  },
  beforeMount () {
    const stratCode = this.$route.query.stratCode
    this.getSelectProductInfo(stratCode)
  },
  beforeDestroy () {
    this.clearSelectProductInfo()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/ProductInfo.vue